import { useReducer, createContext } from 'react';
import { node, oneOfType, arrayOf } from 'prop-types';
import { UNKNOWN_AGENCY_NAME } from 'src/constants/agency';
import { initialState, Reducer } from './Reducer';
import { Actions } from './constants';
import { toSnakeCaseKeys } from 'src/utils/toSnakeCaseKeys';

export const ContextProvider = ({ children }) => {
  const [store, dispatch] = useReducer(Reducer, initialState);
  const getAgentById = id => store.agency.agents.find(agent => agent.id === id);
  const setLoading = payload =>
    dispatch({ type: Actions.SET_LOADING, payload });
  const setAgency = agency => {
    const payload = toSnakeCaseKeys(agency);
    dispatch({
      type: Actions.SET_AGENCY,
      payload: {
        ...payload,
        name: payload.name === UNKNOWN_AGENCY_NAME ? '' : payload.name,
      },
    });
  };
  const setCurrentAgent = agent => {
    dispatch({
      type: Actions.SET_CURRENT_AGENT,
      payload: toSnakeCaseKeys(agent),
    });
  };
  const setOriginalAgent = agent => {
    dispatch({
      type: Actions.SET_ORIGINAL_AGENT,
      payload: toSnakeCaseKeys(agent),
    });
  };
  const updateAgent = agent => {
    const agents =
      store.agency?.agents.map(a => {
        if (a.id === agent.id) {
          return agent;
        } else {
          return a;
        }
      }) || [];
    dispatch({
      type: Actions.SET_AGENCY,
      payload: toSnakeCaseKeys({
        ...store.agency,
        agents,
      }),
    });
    if (agent.id === store.agent.id) {
      setCurrentAgent(agent);
    }
  };
  const setAgents = agents => {
    dispatch({
      type: Actions.SET_AGENTS,
      payload: toSnakeCaseKeys({
        agents,
      }),
    });
  };
  const showRenewalsBanner = () =>
    dispatch({ type: Actions.SHOW_RENEWALS_BANNER });
  const value = {
    store: {
      ...store,
      agent: store.agent || {},
      agency: store.agency || {},
    },
    dispatch,
    getAgentById,
    setLoading,
    setAgency,
    setCurrentAgent,
    setOriginalAgent,
    updateAgent,
    setAgents,
    showRenewalsBanner,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

ContextProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]),
};

export const AppContext = createContext({
  store: initialState,
});
